<template>
  <v-dialog :value="visible" max-width="600px" persistent>
    <v-card>
      <v-card-title>Replace territories</v-card-title>
      <v-card-text>
        <p>Select the new territories for the {{ selectedCount }} selected booking(s).</p>
        <p class="caption grey--text">
          The selected bookings will be moved to the territories below. Bookings whose current territory is not in this list will be removed.
        </p>

        <v-autocomplete
          v-model="selectedRegions"
          :items="regions"
          item-value="id"
          item-text="name"
          label="Regions"
          prepend-icon="dashboard"
          multiple
          chips
          small-chips
          deletable-chips
          clearable
        ></v-autocomplete>

        <v-autocomplete
          v-model="selectedCountries"
          :items="countries"
          item-value="id"
          item-text="name"
          label="Countries"
          prepend-icon="public"
          multiple
          chips
          small-chips
          deletable-chips
          clearable
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">Cancel</v-btn>
        <v-btn color="primary" text :disabled="!isValid" :loading="loading" @click="confirm()">
          Replace with {{ totalTargets }} territor{{ totalTargets === 1 ? 'y' : 'ies' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BulkChangeTerritoryDialog',

  props: {
    visible: { type: Boolean, required: true },
    selectedCount: { type: Number, required: true },
    loading: { type: Boolean, default: false },
  },

  data () {
    return {
      selectedRegions: [],
      selectedCountries: [],
    }
  },

  computed: {
    regions () {
      return this.$store.state.common.regions.filter(val => val.id !== 0)
    },
    countries () {
      return this.$store.state.common.activeCountries
    },
    totalTargets () {
      return this.selectedRegions.length + this.selectedCountries.length
    },
    isValid () {
      return this.totalTargets > 0
    },
  },

  watch: {
    visible (val) {
      if (!val) {
        this.selectedRegions = []
        this.selectedCountries = []
      }
    },
  },

  methods: {
    confirm () {
      if (!this.isValid) return
      this.$emit('confirm', {
        newRegionIDs: this.selectedRegions,
        newCountryIDs: this.selectedCountries,
      })
    },

    cancel () {
      this.selectedRegions = []
      this.selectedCountries = []
      this.$emit('cancel')
    },
  },
}
</script>
